import { FC } from 'react';

interface ICheckIconProps {
  stroke?: string;
}

const CheckIcon: FC<ICheckIconProps> = (props) => {
  const { stroke } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="-2 -1 15 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.096 0.389671L3.93602 7.29967L2.03602 5.26967C1.68602 4.93967 1.13602 4.91967 0.736015 5.19967C0.346015 5.48967 0.236015 5.99967 0.476015 6.40967L2.72602 10.0697C2.94602 10.4097 3.32601 10.6197 3.75601 10.6197C4.16601 10.6197 4.55602 10.4097 4.77602 10.0697C5.13602 9.59967 12.006 1.40967 12.006 1.40967C12.906 0.489671 11.816 -0.320329 11.096 0.379671V0.389671Z"
        fill={stroke ?? 'white'}
      />
    </svg>
  );
};

export default CheckIcon;
